import { WornSkins } from "../skins/wornSkins";

/**
 * Which model the fortress wears (art_review/towers.md F2): `base_t<tier>__<skin>` when the manifest has it
 * (views/common.ts hqTowerName), else the stock one. Since FINISH_PLAN WP8 the answer is the save's `cosmetics`
 * section (features/cosmetics.ts → skins/wornSkins.ts), whose fortress skin names its model; `?skin=<name>` (or
 * `?skin=none`) still overrides it for captures. localStorage `td.baseSkin` was the old device toggle: the cosmetics
 * feature migrates it into the save once and removes it. The debug menu's toggle goes through `debugSet`.
 */
export const BaseSkin = {
  Key: "td.baseSkin",
  /** Skins that ship models (art/hq: base_t1..3__dragonlord, base_t1..3__moonstone, base_t1..3__starfall). */
  Known: ["dragonlord", "moonstone", "starfall"] as readonly string[],
  /** Debug: wears a fortress model skin (null: stock) through the save; features/cosmetics.ts sets it. */
  debugSet: null as ((model: string | null) => void) | null,

  current(): string | null {
    try {
      const q = typeof location !== "undefined" ? new URLSearchParams(location.search).get("skin") : null;
      if (q !== null) return q === "" || q === "none" ? null : q;
    } catch { /* no location */ }
    return WornSkins.fortressModel();
  },

  /** The old device toggle's value, for the one-time migration into the save. */
  legacy(): string | null {
    try { return (typeof localStorage !== "undefined" ? localStorage.getItem(BaseSkin.Key) : null) || null; } catch { return null; }
  },
  clearLegacy(): void {
    try { localStorage.removeItem(BaseSkin.Key); } catch { /* private mode */ }
  },

  /** Debug toggle: none → each known skin → none. Returns the new skin. The hub rebuilds with it. */
  cycle(): string | null {
    const all: (string | null)[] = [null, ...BaseSkin.Known];
    const next = all[(all.indexOf(BaseSkin.current()) + 1) % all.length];
    BaseSkin.debugSet?.(next);
    return next;
  },
};
